import {css} from '@emotion/react'

export const BulletStyle = css`
  .bullet {
    svg {
      margin-left: 20px;
      margin-right: 20px;
      fill: #1f1f1d;
    }
    p {
      color: black;
    }
  }
`
